export const GET_PRODUCTS_START = "[PRODUCTS] START GET ALL PRODUCTS";
export const GET_PRODUCTS_SUCCESS = "[PRODUCTS] GET ALL PRODUCTS SUCCESS";
export const GET_PRODUCTS_FAILURE = "[PRODUCTS] GET ALL PRODUCTS FAILURE";